<template>
    <div>
         <div class="boxShell">
            <i class="iconfont icon-chenggong-icon topicon"></i>
            <p class="tip">恭喜您贷款审批通过</p>
            <p class="detailInst">银行工作人员将会在近日与您联系，请保持手机畅通，</p>
            <p class="detailInst">工作人员会协助您完成提款流程，请耐心等待。</p>
            <div class="stepBox">
                <div class="steps">
                    <div class="stepOne stepCommon">1</div>
                    <div class="stepLine"></div>
                    <div class="stepOne stepCommon">2</div>
                     <div class="stepLine"></div>
                    <div class="stepOne stepCommon">3</div>
                </div>
                <div class="stepsInstruction">
                    <div class="stepsInstructionOne">
                        <p class="stepTitle">银行卡户</p>
                        <p class="stepDetail">若有卡，直接申请</p>
                    </div>
                    <div class="stepsInstructionOne">
                         <p class="stepTitle">面签</p>
                        <p class="stepDetail">身份核实及签署合同</p>
                    </div>
                    <div class="stepsInstructionOne">
                         <p class="stepTitle">提款</p>
                        <p class="stepDetail">获得银行最终放款额</p>
                    </div>
                </div>
            </div>
         </div>
    </div>
</template>
<script>
import { checkStatus } from './mixin';

export default {
  name: 'DrawingMoney',
  data() {
    return {
      danger: 'danger',
      draw: '去提款',
    };
  },
  mixins: [checkStatus],
  mounted() {
    document.getElementById('app').className = 'bgColor';
  },
};
</script>
<style scoped>
    .bgColor {
        background-color: #fff;
    }
    .boxShell {
        padding-top: 103px;
    }
    .topicon {
        margin-top:103px;
        color: #F65249;
        font-size: 60px;
    }
    .tip {
        color: #1C2438;
        font-size: 17px;
        text-align: center;
    }
    .detailInst {
        margin: 0;
        padding:0;
        color: #9EA7B4;
        font-size: 14px;
        letter-spacing: 0;
        text-align: center;
    }
    .stepBox {
        margin-top: 46px;
    }
    .steps {
        float: left;
        width: 14px;
        margin-left: 30px;
        padding-top:22px;
    }
    .stepCommon {
        width: 14px;
        height: 14px;
        color: #FFF;
        font-size: 12px;
        line-height: 14px;
        letter-spacing: 0;
        background: #FDA357;
        border-radius:50%;
    }
    .stepLine {
        width: 2px;
        height: 45px;
        margin: 7px auto;
        background: #FDA357;
    }
    .stepsInstruction {
        float: left;
        margin-left: 7px;
    }
    .stepTitle {
        box-sizing: border-box;
        margin: 0;
        padding:0;
        padding-top: 14px;
        color: #504C51;
        font-size: 10px;
        letter-spacing: 0;
        text-align: left;
    }
    .stepDetail {
        margin: 0;
        padding:0;
        color: #9EA7B4;
        font-size: 10px;
        letter-spacing: 0;
        text-align: left;
    }
    .stepsInstructionOne {
        width: 295px;
        height: 58px;
        margin-bottom:12px;
        background:url("~@/assets/images/stepOne.png") no-repeat;
         background-size: cover;
    }
</style>
